import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardComponent from './components/Dashboard';

const Dashboard = (props) => (
    <Container>
        <DashboardComponent {...props} />
    </Container>
);

Dashboard.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(Dashboard);
